import {
  AnyDocument,
  Evaluatable,
  WorkflowDataResolverDependencies,
} from '~/core/shared/types';
import {
  isSingleEvaluatableString,
  isValueEvaluatable,
  resolveEvaluatable,
} from '~/core/shared/utils/evaluatable';
import { replaceFromParentContext } from './replaceFromParentContext';

export const handleEvaluatableResolver = (
  evaluatable: Evaluatable,
  dependencies: WorkflowDataResolverDependencies,
  parentContext?: AnyDocument,
): string | undefined => {
  if (
    !isValueEvaluatable(evaluatable) ||
    typeof evaluatable.value !== 'string' ||
    !isSingleEvaluatableString(evaluatable.value)
  ) {
    return resolveEvaluatable(evaluatable, dependencies);
  }

  let value = replaceFromParentContext(evaluatable.value, parentContext);

  // If unresolved placeholders remain, use the standard resolver
  if (/\{.*\}/.test(value)) {
    value = resolveEvaluatable(evaluatable, dependencies);
  }

  if (isValueEvaluatable(evaluatable)) {
    if (!evaluatable.transformFuncs?.length) return value;
    return evaluatable.transformFuncs.reduce((acc, fn) => fn(acc), value);
  }
  return value;
};
